import getPathToLayout from "../get-path-to-layout"
import {urlWithTeamId} from "../current-team-url"
import {useCallback} from "react"
import {useNavigate} from "react-router-dom"

export function useLayoutRedirector() {
  const navigate = useNavigate()
  const callback = useCallback(async(layout, pathName, ...args) => {
    const options = isOptionsObject(args[args.length - 1]) ? args.pop() : undefined
    let pathOrUrl = await getPathToLayout(layout, pathName, ...args)

    // The current team is navigation state in the URL, so redirects must carry
    // it too - otherwise the next page falls back to the individual team.
    if (options && "teamId" in options) {
      pathOrUrl = urlWithTeamId(pathOrUrl, options.teamId)
    }

    if (pathOrUrl.match(/^http(s|):\/\//)) {
      location.href = pathOrUrl
    } else {
      navigate(pathOrUrl)
    }
  }, [navigate])

  return callback
}

function isOptionsObject(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value)
}
